var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5C6.125 0.5 0.5 6.125 0.5 13C0.5 19.875 6.125 25.5 13 25.5C19.875 25.5 25.5 19.875 25.5 13C25.5 6.125 19.875 0.5 13 0.5ZM13 23C7.5 23 3 18.5 3 13C3 7.5 7.5 3 13 3C18.5 3 23 7.5 23 13C23 18.5 18.5 23 13 23Z",
    fill: "#0095FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 9.625C13.375 9.125 12.625 9.125 12.125 9.625L8.375 13.375C7.875 13.875 7.875 14.625 8.375 15.125C8.875 15.625 9.625 15.625 10.125 15.125L13 12.25L15.875 15.125C16.125 15.375 16.5 15.5 16.75 15.5C17 15.5 17.375 15.375 17.625 15.125C18.125 14.625 18.125 13.875 17.625 13.375L13.875 9.625Z",
    fill: "#0095FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownClock);
export default __webpack_public_path__ + "static/media/iconDownClock.22214d4d5c20cf686c33ea3f07034996.svg";
export { ForwardRef as ReactComponent };